export default __webpack_public_path__ + "static/media/loginImg.7181d7a1.png";